import { WarningOutlined } from "@ant-design/icons";

const PermissionDenied = () => {
  return (
    <div
      className="flex justify-center items-center flex-col min-h-[80vh]
 text-center"
    >
      <WarningOutlined className="text-[60px] mb-2" />
      <p className="text-[21px] mt-2">
        You do not have permission to access this module.
      </p>
    </div>
  );
};

export default PermissionDenied;
